import React from 'react';

const ScreenSizeContext = React.createContext({
  isSmallScreen: false,
});

export default ScreenSizeContext;
